"use client";

import { useState } from "react";
import { AudioModeToggle } from "@/components/audio-mode-toggle";
import { Chat } from "@/components/chat";
import { ParamInputs } from "@/components/param-inputs";
import { PlaybookSelector, type Selection } from "@/components/playbook-selector";
import { usePlaybookParams } from "@/hooks/usePlaybookParams";
import { useSSESession } from "@/hooks/useSSESession";
import { createSessionFromSelection } from "@/lib/api";
import { type AudioMode } from "@/lib/ws";

export default function TextAudioPage() {
  const [audioMode, setAudioMode] = useState<AudioMode>("file");
  const [isAgent, setIsAgent] = useState(false);
  const { paramNames, paramValues, setParamValues, resetParams, params } = usePlaybookParams();
  const { sessionId, messages, ended, loading, handleSessionStart, handleSend } =
    useSSESession("text2audio", audioMode);

  async function handleStart(selection: Selection) {
    const isAgentSelection = selection.type === "agent_backend";
    setIsAgent(isAgentSelection);
    const res = await createSessionFromSelection(selection, { source: "sandbox:text-audio", mode: "text2audio", params });
    if (isAgentSelection) {
      handleSessionStart(res.session_id, "");
    } else {
      handleSessionStart(res.session_id, res.reply, res.audio_base64, res.cache_hit);
    }
  }

  return (
    <div className="flex h-full flex-col">
      <div className="border-b px-4 py-3">
        <div className="flex items-center gap-3">
          <h1 className="text-sm font-medium shrink-0">文字转语音</h1>
          <PlaybookSelector onStart={handleStart} onPlaybookChange={resetParams} disabled={loading} />
          <AudioModeToggle value={audioMode} onChange={setAudioMode} />
          <ParamInputs params={paramNames} values={paramValues} onChange={setParamValues} disabled={loading} />
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        {sessionId ? (
          <Chat
            messages={messages}
            ended={ended}
            loading={loading}
            onSend={handleSend}
            sessionId={sessionId}
            enableMarkdown={isAgent}
          />
        ) : (
          <div className="flex h-full items-center justify-center text-muted-foreground">
            请选择话术并开始会话
          </div>
        )}
      </div>
    </div>
  );
}
